import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import AppVersion from './AppVersion';

const AppVersionPage = () => {
    return (
        <AdminLayout>
            <AppVersion />
        </AdminLayout>
    );
}

export default AppVersionPage;

  